import { DEFAULT_FORM_STATE } from '../constants/defaultFormState';
import { IFormState, IOption, ISelectedRegion } from '../types/calculator';

export function getInitialCalculatorFormState(preselectedFormValues?: Partial<IFormState>): IFormState {
  return {
    ...DEFAULT_FORM_STATE,
    ...preselectedFormValues,
  };
}

export function getInitialSelectedRegion(
  regionId: string | undefined,
  regionsOptions?: IOption[],
): ISelectedRegion | null {
  if (!regionsOptions?.length || regionId === undefined) {
    return null;
  }

  const matched = regionsOptions.find(option => option.value === String(regionId));

  if (!matched) {
    return null;
  }

  return {
    regionId: Number(matched.value),
    displayName: matched.label,
  };
}
